import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityStaff } from "../../entity/EntityStaff";

export class DtoStaffsPostReq extends EntityStaff {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------

    return res;
  }
}
